export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'
export const PAGE_SIZE = 8
export const AUTH_STORAGE_KEY = 'odonto-clinic-session'

export const DASHBOARD_PERIODS = [
  { label: 'Mês', value: 'month' },
  { label: 'Última semana', value: 'week' },
  { label: 'Hoje', value: 'day' },
]

export const EXPENSES_PERIODS = [
  { label: 'Mês atual', value: 'month' },
  { label: 'Semana', value: 'week' },
  { label: 'Hoje', value: 'day' },
  { label: 'Dados totais', value: 'all' },
]

export const emptyForm = {
  name: '',
  procedure: '',
  value: '',
  duration_minutes: '',
  payment_type: 'particular',
  cpf: '',
  date: '',
}

export const emptyFilters = {
  name: '',
  procedure: '',
  payment_type: '',
  min_value: '',
  max_value: '',
  duration_minutes: '',
  start_date: '',
  end_date: '',
}

export const PROCEDURE_OPTIONS = [
  'Limpeza',
  'Restauração',
  'Facetas',
  'Manutenção',
  'Manutenção Facetas',
  'Clareamento',
  'Extração',
  'Avaliação Inicial',
  'Tratamento de Canal',
  'Implantes',
]
